import axios from 'axios';
import type { SupraSystemSubscriptionType } from '@bb/domain/dist/types/SupraSystemSubscription';

const addManualCoopKey = async ({
  keySerialNumber,
  pin,
  userId,
}: {
  keySerialNumber: number;
  pin: string;
  userId?: string;
}): Promise<SupraSystemSubscriptionType | null> => {
  const payload: { keySerialNumber: number; pin: string; userId?: string } = {
    keySerialNumber,
    pin,
    userId,
  };

  const { data } = await axios.post<SupraSystemSubscriptionType | null>(
    '/supra/manual_coop_key',
    payload,
  );
  return data;
};

export default addManualCoopKey;
